import { Component, OnInit } from '@angular/core';
import { CoreService } from 'src/app/core/helpers/core.service';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { GaService } from '../../core/helpers/ga.service';


@Component({
  selector: 'loyaltic-nick-name',
  templateUrl: './nick-name.component.html',
  styleUrls: ['./nick-name.component.scss']
})
export class NickNameComponent implements OnInit {
  nickName = '';
  selectedAvatar = '';
  constructor(private coreService: CoreService,
    private authService: AuthService,
    private gaService: GaService,
    private readonly translate: TranslateService,
    private toast: ToastrService,
    private router: Router) { }

  ngOnInit() {
  }

  onSubmit(form) {
    form.submitted = false;
    this.coreService.checkNickNameExists(this.nickName).then((response: any) => {
      if (response.messageKey === 'info-nickname-notexist') {
        const body = { NickName: this.nickName, UserId: this.authService.getUserId(), AvatarName: this.selectedAvatar };
        this.coreService.captureNickName(body).then((nickNameResponse: any) => {
          localStorage.setItem('nickNameExists', 'True');
          this.gaService.emitEvent('gameplay', 'Game Screen');
          localStorage.setItem('gameurl', nickNameResponse.result.gameurl);
          this.router.navigateByUrl('/captureImage');
        });
      } else {
        this.toast.error(this.translate.instant('error-nickname-already-exist'), this.translate.instant('error'));
        return;
      }
    });
  }

  selectAvatar(avatarName: string) {
    this.selectedAvatar = avatarName;
  }
}
